import ProfilePic from "../../../img/portfolio-freelance.jpg"
import ProfilePic2 from "../../../img/screenshot-jevelin-startup-clean.jpg"
export const Data=[
{
    pic:ProfilePic,
    pic2:ProfilePic2,
    name:`Hamza Ashfaq`,
    age:19,
    experiance:"2 years",
    country:"Pakistan",
    location:"Lahore",
    email:"hamzaashfaq7866@gmail.com",
    phone:"+923114340230",
    freelance:"Available",
    downloadResume:"Download Template",
    contact:"Live Demo"
}
]